import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from '/webresources-sources/js/util/jquery';

/**
 * This JS class contains the logic to pause/resume the video background.
 *
 * It also shows/hides the related button element based on the current playing state.
 */
export default class HeroComponent extends BaseComponent {
    events() {
        return {
            '[data-toggle="play"]': {
                click: (e) => {
                    e.preventDefault();

                    let videos = this.findVideoElements();
                    if (videos) {
                        for (let video of videos) {
                            video.play();
                        }

                        this.switchButtonVisibility(true);
                    }
                },
            },
            '[data-toggle="pause"]': {
                click: (e) => {
                    e.preventDefault();

                    let videos = this.findVideoElements();
                    if (videos) {
                        for (let video of videos) {
                            video.pause();
                        }

                        this.switchButtonVisibility(false);
                    }
                },
            },
        };
    }

    findVideoElements() {
        let videos = this.element.getElementsByTagName('video');
        return videos.length > 0 ? videos : undefined;
    }

    switchButtonVisibility(playing) {
        const videoStopper = this.element.querySelector('.video-stopper');
        if (videoStopper) {
            if (playing) {
                videoStopper.classList.remove('d-none');
            } else {
                videoStopper.classList.add('d-none');
            }
        }

        const videoStarter = this.element.querySelector('.video-starter');
        if (videoStarter) {
            if (playing) {
                videoStarter.classList.add('d-none');
            } else {
                videoStarter.classList.remove('d-none');
            }
        }
    }
}

defineComponent('hero-component', HeroComponent);
